import { render, staticRenderFns } from "./SmokeWork.vue?vue&type=template&id=c5971124&scoped=true"
import script from "./SmokeWork.vue?vue&type=script&lang=js"
export * from "./SmokeWork.vue?vue&type=script&lang=js"
import style0 from "./SmokeWork.vue?vue&type=style&index=0&id=c5971124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5971124",
  null
  
)

export default component.exports